/**
 * The header operator switcher's people (PR 8, plan D2).
 *
 * The switcher used to list every active bbpro_operators row
 * (GET /api/operators), so service accounts ("clickpay-mcp-full", "Test
 * Account") showed up as teammates, and it matched "me" by comparing emails
 * in the browser. It now reads the same list as the Daily Brief's person
 * chips — GET /api/brief/tabs, where the server keeps people only
 * (backend/api/people.is_person, Nuchem included) and resolves the viewer's
 * own slug — so the two can never disagree about who works here.
 */
import type { BriefTabOperator, BriefTabsResponse } from './api'

export type SwitcherPerson = Pick<BriefTabOperator, 'slug' | 'display_name' | 'color'>

export type SwitcherOptions = {
  /** The signed-in person's own row ("My products"); null in open mode or
   *  when the server could not tell who is asking. */
  me: SwitcherPerson | null
  /** Everyone else, in the server's order (by name). */
  teammates: SwitcherPerson[]
}

export function switcherOptions(tabs: BriefTabsResponse | null | undefined): SwitcherOptions {
  const people: SwitcherPerson[] = (tabs?.operators ?? []).map((o) => ({
    slug: o.slug, display_name: o.display_name, color: o.color,
  }))
  const viewer = tabs?.viewer ?? null
  const me = viewer ? people.find((p) => p.slug === viewer) ?? null : null
  return { me, teammates: people.filter((p) => p.slug !== me?.slug) }
}
